import styled from "styled-components";

export const StyledUploadIndicator = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;

    .ant-badge-count {
        background: ${({ theme }) => theme.additionalTypographyColor};
        font-size: 10px;
        top: 5px;
        right: 5px;
    }
`;
